import { render, staticRenderFns } from "./OpenEndedGroupingButton.vue?vue&type=template&id=628090c4&scoped=true"
import script from "./OpenEndedGroupingButton.vue?vue&type=script&lang=js"
export * from "./OpenEndedGroupingButton.vue?vue&type=script&lang=js"
import style0 from "./OpenEndedGroupingButton.vue?vue&type=style&index=0&id=628090c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628090c4",
  null
  
)

export default component.exports